module.exports = __webpack_public_path__ + "img/article-writer.a73bdda7.png";